import React, { useState } from "react";
import classNames from "classnames";
import styles from "./Helper.module.scss";

const Helper: React.FC = () => {
  const [visible, setIsVisible] = useState<boolean>(false);

  const openInfo = (): void => {
    setIsVisible(!visible);
  };

  const infoClassname = classNames(styles.helper__container__info, {
    [styles.helper__container__info__active]: visible,
  });

  return (
    <div className={styles.helper}>
      <div className={styles.helper__container}>
        <div className={styles.helper__content}>
          <p
            role="button"
            onClick={openInfo}
            className={styles.helper__container__link__help}
          >
            Help
          </p>
        </div>

        <div className={infoClassname}>
          <p className={styles.helper__container__info__text}>
            This application helps you find the nearset path from one node to
            another based on node coordinates, link lengths or nodes weight.
          </p>
          <p className={styles.helper__container__info__text}>
            <strong>Click on node</strong>: Select node
          </p>
          <p className={styles.helper__container__info__text}>
            Select nodes and click search button to find nearest path from one
            node to another. If you select more than 2 nodes, paths are gonna be
            chained.
          </p>

          <p className={styles.helper__container__info__text}>
            Click on magic button to load example graph.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Helper;
